import { EcommerceAPI } from "../Client";

export const getCustomFilterApi = async (id) => {
  try {
    const response = await EcommerceAPI.get(`/product/custom-filter?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const createCustomFilterApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post("/product/custom-filter", payload);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateCustomFilterApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put("/product/custom-filter", payload);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteCustomFilterApi = async (id) => {
  try {
    const response = await EcommerceAPI.delete(`/product/custom-filter?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getCustomFiltersApi = async () => {
  try {
    const response = await EcommerceAPI.get("/product/custom-filters");
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getAgeFilterApi = async (id) => {
  try {
    const response = await EcommerceAPI.get(`/product/age-filter?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const createAgeFilterApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post("/product/age-filter", payload);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateAgeFilterApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put("/product/age-filter", payload);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteAgeFilterApi = async (id) => {
  try {
    const response = await EcommerceAPI.delete(`/product/age-filter?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getAgeFiltersApi = async () => {
  try {
    const response = await EcommerceAPI.get("/product/age-filters");
    return response;
  } catch (error) {
    throw error.response || error;
  }
};
